import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import {
  SnapshotHistorySetting,
  UpdateManySnapshotHistorySettingDto,
} from 'types';

export const updateMultipleSnapshotHistorySettings = ({
  data,
}: {
  data: UpdateManySnapshotHistorySettingDto;
}): Promise<SnapshotHistorySetting> => {
  return axios.post(`/api/snapshots/history/settings`, data);
};

type UseUpdateMultipleSnapshotHistorySettingsOptions = {
  config?: MutationConfig<typeof updateMultipleSnapshotHistorySettings>;
};

export const useUpdateMultipleSnapshotHistorySettings = ({
  config,
}: UseUpdateMultipleSnapshotHistorySettingsOptions) => {
  return useMutation({
    onMutate: async (updatedHistorySettings) => {
      await queryClient.cancelQueries(['snapshot', 'historySettings']);

      const previousSnapshotHistorySettingss =
        queryClient.getQueryData<SnapshotHistorySetting>([
          'snapshot',
          'historySettings',
        ]);

      queryClient.setQueryData(
        ['snapshot', 'historySettings'],
        updatedHistorySettings
      );

      return { previousSnapshotHistorySettingss };
    },
    onError: (_, __, context: any) => {
      if (context?.previousSnapshotHistorySettingss) {
        queryClient.setQueryData(
          ['snapshot', 'historySettings'],
          context.previousSnapshotHistorySettingss
        );
      }
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['snapshot', 'historySettings']);
    },
    ...config,
    mutationFn: updateMultipleSnapshotHistorySettings,
  });
};
